import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import ApiService from "./common/api.service";
import { RESET_CONFIG } from "./store/actions.type";
import Imgsrc from "./common/src.filter";
import DateFilter from "./common/date.filter";
import VueFullPage from 'vue-fullpage.js'

import VueMeta from 'vue-meta'


Vue.use(VueFullPage);
Vue.use(VueMeta)
Vue.config.productionTip = false
Vue.filter("imgsrc", Imgsrc);
Vue.filter("date", DateFilter);
ApiService.init();

router.beforeEach((to, from, next) =>
  Promise.all([store.dispatch(RESET_CONFIG)]).then(next)
);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
